export default "__VITE_ASSET__BRdBtf0J__"